import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Login',
    component: resolve => require(['../iview/Login.vue'], resolve)
  }, {
    path: '/subSuccess',
    name: 'SubSuccess',
    component: resolve => require(['../iview/SubSuccess.vue'], resolve)
  }, {
    path: '/activityTwo',
    name: 'ActivityTwo',
    component: resolve => require(['../iview/ActivityTwo.vue'], resolve)
  }, {
    path: '/activityFour',
    name: 'ActivityFour',
    component: resolve => require(['../iview/ActivityFour.vue'], resolve)
  }, {
    path: '/login',
    name: 'Login',
    component: resolve => require(['../iview/Login.vue'], resolve)
  }, {
    path: '/activityThree',
    name: 'ActivityThree',
    component: resolve => require(['../iview/ActivityThree.vue'], resolve)
  }, {
    path: '/home',
    name: 'Home',
    component: resolve => require(['../iview/Home.vue'], resolve)
  }, {
    path: '/activityOne',
    name: 'ActivityOne',
    component: resolve => require(['../iview/ActivityOne.vue'], resolve)
  }, {
    path: '/activityFive',
    name: 'ActivityFive',
    component: resolve => require(['../iview/ActivityFive.vue'], resolve)
  }, {
    path: '/mywork',
    name: 'Mywork',
    component: resolve => require(['../iview/Mywork.vue'], resolve)
    }, {
      path: '/activityRule',
      name: 'ActivityRule',
      component: resolve => require(['../iview/ActivityRule.vue'], resolve)
    }, {
      path: '/infoData',
      name: 'InfoData',
      component: resolve => require(['../iview/InfoData.vue'], resolve)
    }, {
      path: '/head',
      name: 'Head',
      component: resolve => require(['../iview/Head.vue'], resolve)
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js